import type {ItemsCategoryPropertyFiltersFormValues} from '../modules/public/ads/AdsModuleTypes'
import {ungzipBase64EncodedString} from './ungzipBase64EncodedString'

// Декодирует строку фильтров в gzip + base64 виде в объект фильтров.
export async function decodeItemsSearchFiltersFromUrlQueryParam(
    encodedFilters?: string | null
): Promise<ItemsCategoryPropertyFiltersFormValues['props']> {
    if (typeof encodedFilters !== 'string' || encodedFilters.trim().length === 0) {
        return {}
    }
    try {
        if (encodedFilters[0] === '{') {
            // Строка уже в JSON формате.
            return JSON.parse(encodedFilters) as ItemsCategoryPropertyFiltersFormValues['props']
        }
        const decoded = await ungzipBase64EncodedString(encodedFilters)
        return JSON.parse(decoded) as ItemsCategoryPropertyFiltersFormValues['props']
    } catch (_e) {
        // Не выводим и не логируем ошибку т.к. могут заспамить кривыми запросами.
        return {}
    }
}
